export const routeMap = {
  about: {
    en: 'about-me',
    hr: 'o-meni',
  },
  contact: {
    en: 'contact',
    hr: 'kontakt',
  },
  bakery: {
    en: 'bakery-app',
    hr: 'pekara-app',
  },
  design: {
    en: 'design-system',
    hr: 'dizajn-sistem',
  },
  villa: {
    en: 'little-villa',
    hr: 'villa-mala',
  },
  soa: {
    en: 'soa',
    hr: 'soa-hr',
  },
  medic: {
    en: 'medic-villa',
    hr: 'villa-medic',
  },
  cps: {
    en: 'cps',
    hr: 'cps-hr',
  },
  homeswitch: {
    en: 'homeswitch',
    hr: 'homeswitch-hr',
  },
  boatrentalsbrac: {
    en: 'boatrentalsbrac',
    hr: 'boatrentalsbrac-hr',
  },
  kucni: {
    en: 'house-flow',
    hr: 'kucni-red',
  },
  scooter: {
    en: 'st-scooter',
    hr: 'st-skuter',
  },
  cs: {
    en: 'croatiasoundworks',
    hr: 'croatiasoundworks-hr',
  },
};